import { StepNoticeType } from '@partful/instructions-domain-models';
import { z } from 'zod';

export const StepNotice = z.object({
  id: z.string().optional(),
  type: z.union(
    [
      z.literal(StepNoticeType.Info),
      z.literal(StepNoticeType.Safety),
      z.literal(StepNoticeType.Warning),
      z.literal(StepNoticeType.Danger),
    ],
    { required_error: 'instructions:step.notice.type.validation.required' }
  ),
  title: z
    .string({ required_error: 'instructions:step.notice.title.validation.required' })
    .trim()
    .min(1, 'instructions:step.notice.title.validation.required')
    .max(400, 'instructions:step.notice.title.validation.maxLength'),
  description: z
    .string({ required_error: 'instructions:step.notice.description.validation.required' })
    .trim()
    .min(1, 'instructions:step.notice.description.validation.required')
    .max(50_000, 'instructions:step.notice.description.validation.maxLength'),
});

export type StepNotice = z.infer<typeof StepNotice>;
